import { Axios } from '@src/app/context/Api/includes/Axios';
import { logger } from '@src/shared/includes/logger';
import { config } from '@uhg-abyss/web/tools/config';

/**
 * SaveActionPathNote
 *
 * Saves a note to an  action path with the remote API via an authenticated request.
 *
 * @param payload
 * @returns {Promise<any>}
 * @constructor
 */
export const SaveActionPathNote = async (payload = {}) => {
  try {
    const theApiKey = payload?.[0];
    const theMutationKey = payload?.[1];
    const thePayload = payload?.[2];

    const requestArgs = {
      baseURL: config('API_URL'),
      data: {
        note: thePayload?.note,
      },
      headers: {
        'x-api-endpoint': `/action-paths/${thePayload?.actionPathId}/note`,
      },
      method: 'PUT',
      params: { apiKey: theApiKey, mutationKey: theMutationKey },
    };

    const remoteResponse = await Axios.request(requestArgs);

    return remoteResponse.data;
  } catch (error) {
    logger.error(
      'src/entities/ActionPath/api/requests/mutations/SaveActionPathNote.js -> SaveActionPathNote()',
      false,
      error
    );

    throw error;
  }
};
